/**
 * Client mirror of functions/stripeCardFees.js — preview card totals before Checkout.
 */

export const STRIPE_PERCENT_FEE = 0.029;
export const STRIPE_FIXED_FEE_CENTS = 30;

export function estimateStripeFeeCents(chargeCents) {
  const charge = Math.max(0, Math.round(Number(chargeCents) || 0));
  return Math.round(charge * STRIPE_PERCENT_FEE + STRIPE_FIXED_FEE_CENTS);
}

export function netAfterStripeFeeCents(chargeCents) {
  const charge = Math.max(0, Math.round(Number(chargeCents) || 0));
  return charge - estimateStripeFeeCents(charge);
}

export function grossUpCardChargeCents(netAmountCents) {
  const netCents = Math.max(0, Math.round(Number(netAmountCents) || 0));
  if (netCents === 0) {
    return { netCents: 0, processingFeeCents: 0, chargeCents: 0 };
  }

  let chargeCents = Math.floor(
    (netCents + STRIPE_FIXED_FEE_CENTS) / (1 - STRIPE_PERCENT_FEE)
  );
  if (chargeCents < netCents) chargeCents = netCents;

  while (netAfterStripeFeeCents(chargeCents) < netCents) {
    chargeCents += 1;
  }

  return {
    netCents,
    processingFeeCents: chargeCents - netCents,
    chargeCents,
  };
}
